const { log } = console
const lzma = require('json-url')('lzma')
const { generateSaveData } = require('./utils/save-load-scene.js')
const {fetchArrayBuffer} = require('./utils/fetch-and-parse.js')

function navigateWithoutReferrerInHeader (url) {
  const link = document.createElement('a')
  link.referrerPolicy = 'no-referrer'
  link.rel = 'noreferrer'
  link.href = url
  link.click()
}

module.exports = function store (state, emitter) {
  emitter.on('share', () => {
    log('share')
    lzma.compress(generateSaveData(state)).then(result => {
      navigateWithoutReferrerInHeader(`/share?shareData=${result}`)
    })
  })

  emitter.on('load-from-share-url', dataString => {
    log('load-from-share-url', dataString)
    lzma.decompress(dataString).then(gameData => {
      state.sceneMetadata = gameData
      state.projectMetadata = {id: gameData.projectId}
      state.projectId = gameData.projectId
      if (!gameData.id) {
        gameData.id = gameData.projectId
      }
      state.sceneId = gameData.sceneId
      const project = state.availableProjects.find(p => p.id === gameData.id)
      const scene = project.scenes.find(s => s.id === state.sceneId)
      const sb3Path = scene.sb3
      if (state.availableProjects.find(p => p.id === gameData.id)) {
        fetchArrayBuffer(
          `/provision/projects/${gameData.id}/${sb3Path}`
        ).then(sb3 => {
          state.sceneData = sb3
          emitter.emit('render')
        })
      } else {
        state.sceneData = {attemptRemoteLoad: true, id: state.projectId}
        emitter.emit('render')
      }
    })
  })
}
